'use client';

import { createIcon } from './utils';

import type { TSVGIcon } from './interface';

export const NextIcon: TSVGIcon = createIcon({
  displayName: 'NextIcon',
  viewBox: '0 0 24 24',
  path: (
    <path d='M14.47 16.53a.75.75 0 0 1 0-1.06l2.72-2.72H5a.75.75 0 0 1 0-1.5h12.188L14.47 8.531a.75.75 0 1 1 1.061-1.061l4 4a.749.749 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.061 0Z' />
  ),
});
